import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopandharpururbaniatour() {



    const cardData =
    {
        keyword: 'Pune to Pandharpur Urbania Tour Package',
        heading: 'Urbania on rent in pune: Pune to Pandharpur Urbania Tour Package',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Pune to Pandharpur Urbania Tour Package services for pilgrims, families, corporate groups, and devotees planning a comfortable spiritual journey to Pandharpur. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for long-distance pilgrimage travel, group tours, and temple visits. With professional chauffeurs experienced on pilgrimage routes, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free darshan experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Pune to Pandharpur Urbania tour packages.',

        top: 'Top Places to Visit in Pandharpur with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Shri Vitthal Rukmini Mandir",
    "description": "Shri Vitthal Rukmini Mandir is the spiritual heart of Pandharpur and one of the most important pilgrimage sites in Maharashtra. Dedicated to Lord Vitthal (Vithoba), an incarnation of Lord Krishna, the temple stands on the banks of the Chandrabhaga River. Millions of devotees, especially Warkaris, visit during Ashadhi and Kartiki Ekadashi, walking long distances in devotional processions. The black stone idol of Vitthal standing on a brick symbolizes devotion, equality, and Bhakti movement traditions."
  },
  {
    "title": "Chandrabhaga (Bhima) River Ghat",
    "description": "The Chandrabhaga River Ghat is a sacred bathing place for devotees visiting Pandharpur. Pilgrims take holy dips in the river before entering the Vitthal temple, believing it purifies the soul. The crescent-shaped river bend gives the ghat its name Chandrabhaga. During Ekadashi festivals, the ghats are filled with devotional chants, bhajans, and a deeply spiritual atmosphere that defines Pandharpur’s religious essence."
  },
  {
    "title": "Pundalik Temple",
    "description": "Pundalik Temple is dedicated to Sant Pundalik, the devotee whose devotion brought Lord Vitthal to Pandharpur. Located near the riverbank, this ancient temple holds great mythological significance. It is believed that Lord Vitthal stood on a brick here waiting for Pundalik, symbolizing the importance of devotion and service to parents. The temple offers a peaceful and reflective spiritual environment."
  },
  {
    "title": "Kaikadi Maharaj Math",
    "description": "Kaikadi Maharaj Math is a sacred religious institution associated with the Warkari tradition. It serves as a resting and worship place for pilgrims during their journey to Pandharpur. The math preserves devotional practices, bhajans, and teachings of saints, offering visitors insight into Maharashtra’s rich Bhakti culture and spiritual heritage."
  },
  {
    "title": "Vishnupad Temple",
    "description": "Vishnupad Temple is believed to mark the footprints of Lord Vishnu on the banks of the Chandrabhaga River. Devotees visit this site to perform rituals and seek blessings for ancestors. The serene riverfront location and spiritual significance make it an important stop for pilgrims seeking peace and divine connection."
  },
  {
    "title": "ISKCON Pandharpur",
    "description": "ISKCON Pandharpur is a modern spiritual center dedicated to Lord Krishna and Lord Vitthal. The temple complex is beautifully maintained and offers daily aartis, kirtans, and spiritual discourses. It attracts devotees from across India and abroad, providing a clean, calm, and organized devotional experience."
  },
  {
    "title": "Gopalpur Temple",
    "description": "Gopalpur Temple is located in the nearby village of Gopalpur and is closely associated with Pandharpur’s pilgrimage circuit. Devotees often visit this temple before entering the main Vitthal temple. The peaceful rural surroundings and traditional rituals make it a spiritually enriching stop."
  },
  {
    "title": "Sant Dnyaneshwar Maharaj Samadhi",
    "description": "This sacred site commemorates Sant Dnyaneshwar Maharaj, one of the greatest saints of the Bhakti movement. Pilgrims pay respects here to honor his contribution to Marathi devotional literature and philosophy. The samadhi is a place of meditation, reflection, and spiritual inspiration."
  },
  {
    "title": "Sant Tukaram Maharaj Temple",
    "description": "Dedicated to Sant Tukaram Maharaj, this temple celebrates the life and teachings of one of Maharashtra’s most beloved Bhakti saints. The temple reflects the simplicity, devotion, and social reform ideals preached by Tukaram Maharaj. It is an important cultural and spiritual landmark for devotees."
  },
  {
    "title": "Ekadashi Palkhi Route",
    "description": "The Ekadashi Palkhi Route is not a single monument but a sacred pilgrimage path used by thousands of Warkaris walking towards Pandharpur. During Ashadhi Ekadashi, the route comes alive with devotional singing, discipline, and unity. Experiencing this route offers deep insight into Maharashtra’s living Bhakti tradition and communal spirituality."
  }
],




"services": [
{
"name": "Pune to Pandharpur Urbania Tour Package",
"description": "Pune to Pandharpur Urbania Tour Package offers a well-planned and comfortable pilgrimage journey for devotees visiting the Pandharpur Vitthal temple. The package includes clean and spacious Urbania buses, experienced chauffeurs, and carefully scheduled travel to ensure a peaceful and spiritually fulfilling yatra from Pune."
},
{
"name": "Pandharpur Urbania Hire from Pune",
"description": "Pandharpur Urbania Hire from Pune provides reliable Urbania bus rental services for one-day or multi-day temple tours. Designed for families and groups, the service focuses on safe travel, comfortable seating, and timely arrivals at Pandharpur."
},
{
"name": "Urbania Bus Rental Pune to Pandharpur",
"description": "Urbania Bus Rental Pune to Pandharpur offers well-maintained buses suitable for long-distance pilgrimage travel. With ample legroom, luggage space, and smooth ride quality, it ensures a relaxed journey for devotees traveling from Pune."
},
{
"name": "Urbania AC Bus Pandharpur Tour",
"description": "Urbania AC Bus Pandharpur Tour provides fully air-conditioned buses for a comfortable and climate-controlled journey. This service is ideal for senior citizens and families seeking a relaxed travel experience during the Pandharpur darshan tour."
},
{
"name": "Family Pandharpur Yatra Urbania Pune",
"description": "Family Pandharpur Yatra Urbania Pune is specially designed for family groups, offering safe, spacious, and comfortable travel arrangements that make the pilgrimage enjoyable for all age groups."
},
{
"name": "Corporate Pandharpur Tour Urbania Pune",
"description": "Corporate Pandharpur Tour Urbania Pune offers organized transport solutions for corporate groups planning spiritual tours or group pilgrimages, ensuring punctual schedules, professional drivers, and smooth coordination."
},
{
"name": "Luxury Urbania Pandharpur Tour",
"description": "Luxury Urbania Pandharpur Tour delivers a premium travel experience with modern interiors, plush seating, and superior comfort, making the pilgrimage journey both spiritual and luxurious."
},
{
"name": "Affordable Pandharpur Tour Urbania Pune",
"description": "Affordable Pandharpur Tour Urbania Pune provides budget-friendly Urbania bus rentals without compromising on safety or comfort, making it ideal for cost-conscious devotees and group travelers."
},
{
"name": "Chauffeur Driven Urbania Pandharpur Yatra",
"description": "Chauffeur Driven Urbania Pandharpur Yatra ensures a stress-free pilgrimage with trained and route-experienced drivers who handle long-distance travel smoothly and safely."
},
{
"name": "Best Pandharpur Urbania Package Pune",
"description": "Best Pandharpur Urbania Package Pune offers complete yatra solutions covering travel, comfort, and reliability, making it a preferred choice for devotees seeking a well-managed Pandharpur tour."
},
{
"name": "Group Travel Pandharpur Urbania",
"description": "Group Travel Pandharpur Urbania provides spacious and reliable bus services for large groups, ensuring everyone travels together comfortably and reaches Pandharpur on time."
},
{
"name": "Pilgrimage Urbania Hire Pune",
"description": "Pilgrimage Urbania Hire Pune specializes in religious travel services, offering clean buses, courteous drivers, and well-organized travel plans for temple tours and spiritual journeys."
},
{
"name": "Pune Pandharpur Darshan Bus Booking",
"description": "Pune Pandharpur Darshan Bus Booking enables easy and hassle-free booking of Urbania buses, ensuring smooth coordination, timely departures, and a comfortable pilgrimage experience."
},
{
"name": "Trusted Pandharpur Urbania Service",
"description": "Trusted Pandharpur Urbania Service is known for dependable operations, customer satisfaction, and safe travel standards, making it a reliable choice for Pandharpur temple tours."
},
{
"name": "Pandharpur Temple Tour Urbania Pune",
"description": "Pandharpur Temple Tour Urbania Pune offers dedicated Urbania buses for temple visits, ensuring a peaceful, comfortable, and spiritually enriching journey for devotees traveling from Pune."
}
],
"tableData": [
["Pune to Pandharpur Urbania Tour Package", "Pandharpur Urbania Hire from Pune"],
["Urbania Bus Rental Pune to Pandharpur", "Urbania AC Bus Pandharpur Tour"],
["Family Pandharpur Yatra Urbania Pune", "Corporate Pandharpur Tour Urbania Pune"],
["Luxury Urbania Pandharpur Tour", "Affordable Pandharpur Tour Urbania Pune"],
["Chauffeur Driven Urbania Pandharpur Yatra", "Best Pandharpur Urbania Package Pune"],
["Group Travel Pandharpur Urbania", "Pilgrimage Urbania Hire Pune"],
["Pune Pandharpur Darshan Bus Booking", "Trusted Pandharpur Urbania Service"],
["Pandharpur Temple Tour Urbania Pune", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Pune to Pandharpur Urbania Tour Package for Comfortable Pilgrimage",
        "WhyChoosedescription": "Pune to Pandharpur Urbania Tour Package is ideal for devotees, families, and groups planning a peaceful and well-organized pilgrimage to Pandharpur with complete travel comfort."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses for Pune to Pandharpur travel are equipped with air-conditioning, comfortable reclining seats, ample legroom, and sufficient luggage space for a relaxed journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Pandharpur Route",
        "WhyChoosedescription": "All drivers are trained and experienced with the Pune to Pandharpur route, ensuring safe travel, timely arrival, and stress-free darshan."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Pune to Pandharpur Urbania Tour Package offers competitive pricing with no hidden charges, making your pilgrimage economical and worry-free."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated customer support for tour planning, scheduling, and last-minute requirements."
    },
    {
        "WhyChooseheading": "Flexible Tour Packages",
        "WhyChoosedescription": "Available for one-day, two-day, and customized Pandharpur tour packages based on group size, travel schedule, and temple visit preferences."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and well-maintained to ensure passenger comfort and hygiene during the journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Tour Service",
        "WhyChoosedescription": "Our Pune to Pandharpur Urbania Tour Package ensures on-time pickups, smooth travel, and reliable service throughout the pilgrimage."
    }
]
}
const faqData = [
    {
        question: 'Can Pune to Pandharpur Urbania Tour Package be booked for group pilgrimages?',
        answer: 'Yes, it is perfect for group pilgrimages, family trips, senior citizen tours, and devotional travel.'
    },
    {
        question: 'How can I book Pune to Pandharpur Urbania Tour Package?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Pune to Pandharpur Urbania Tour Package?',
        answer: 'This package offers comfortable travel, experienced drivers, clean vehicles, flexible tour options, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced for the Pandharpur route?',
        answer: 'Yes, all drivers are trained and familiar with the Pune to Pandharpur route and temple timings.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Pune and nearby areas.'
    },
    {
        question: 'Is Pune to Pandharpur Urbania Tour Package available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety and comfort.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the tour?',
        answer: 'Yes, dedicated customer support is available throughout the Pandharpur journey.'
    },
    {
        question: 'Is this tour suitable for families and senior citizens?',
        answer: 'Yes, Pune to Pandharpur Urbania Tour Package is ideal for families, senior citizens, and devotional groups.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Dattatray Kulkarni',
        feedback: 'Our Pune to Pandharpur trip was very comfortable. The Urbania bus was clean, spacious, and perfect for a devotional journey.',
        rating: 5
    },
    {
        id: 2,
        name: 'Mrs. Vaishali Deshpande',
        feedback: 'Excellent tour package to Pandharpur. Professional driver, smooth travel, and well-managed schedule. Highly satisfied.',
        rating: 5
    }
];







































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Pandharpur Urbania Tour Package",
  "image": "https://urbaniaonrentpune.in/assets/images/pune-pandharpur-urbania.jpg",
  "description": "Pune to Pandharpur Urbania Tour Package offers AC Urbania buses for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation from Pune to Pandharpur temples.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-pandharpur-urbania-tour-package"
  }
};







    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Pandharpur Urbania Tour Package | AC Urbania Bus One Way & Round Trip 
  </title>

  <meta
    name="description"
    content="Book Pune to Pandharpur Urbania Tour Package for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation from Pune to Pandharpur temples."
  />

  <meta
    name="keywords"
    content="Pune to Pandharpur Urbania Tour Package, Pandharpur Urbania Hire from Pune, Urbania Bus Rental Pune to Pandharpur, Urbania AC Bus Pandharpur Tour, Family Pandharpur Yatra Urbania Pune, Corporate Pandharpur Tour Urbania Pune, Luxury Urbania Pandharpur Tour, Affordable Pandharpur Tour Urbania Pune, Chauffeur Driven Urbania Pandharpur Yatra, Best Pandharpur Urbania Package Pune, Group Travel Pandharpur Urbania, Pilgrimage Urbania Hire Pune, Pune Pandharpur Darshan Bus Booking, Trusted Pandharpur Urbania Service, Pandharpur Temple Tour Urbania Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/85.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetopandharpururbaniatour;